/**
 * @file isLastQuestion.ts
 * Exports a method that determines if a question is the last one to display.
 */
import { last, propEq } from 'ramda';
import { getQuestions } from './index';
import type { AppState } from '../types';

/**
 * Helper method that determines if a given question is the last one to display.
 *
 * This is currently a simple process that assumes the last question to display
 * is literally the last question in the JSON data. In the future this will
 * not be true as questions can have conditional display logic.
 *
 * @param {AppState} state
 *   The state object shared across the application.
 * @param {string} id
 *   The id of a question in the QuestionData.
 *
 * @returns {boolean}
 *   TRUE if the input has the id of the last question.
 */
export default (appState: AppState, id: string): boolean =>
  propEq('id', id)(last(getQuestions(appState)));
